<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { locationParts } from '@/utils/countries'

const props = withDefaults(defineProps<{
  countryCode?: string | null
  location?: string | null
  flagCode?: string | null
  inline?: boolean
  size?: number
}>(), {
  countryCode: null,
  location: null,
  flagCode: null,
  inline: false,
  size: 24,
})

const user = useUserStore()

const lang = computed<'ru' | 'en'>(() => (user.profile?.language === 'en' ? 'en' : 'ru'))
const info = computed(() => locationParts(props.countryCode, props.location, lang.value, props.flagCode))
</script>

<template>
  <div
    class="flex items-center gap-2"
    :class="inline ? 'inline-flex align-middle' : ''"
  >
    <img
      v-if="info.flagUrl"
      :width="size"
      :height="Math.round(size * 0.75)"
      :src="info.flagUrl"
      class="max-w-none shrink-0 rounded-sm object-cover"
      :alt="info.name"
      loading="lazy"
      @error="($event.target as HTMLImageElement).style.display = 'none'"
    />
    <div>{{ info.name }}</div>
  </div>
</template>
